import { Formik } from "formik";
import {
  Grid,
  Button,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  OutlinedInput,
} from "@mui/material";

import SubmitButton from "components/Button/SubmitButton";
import { insuranceSchema } from "schemas/insuranceSchema";
import states from "components/pages/transmissions/modal/patient/static/states";
import useInsuranceForm from "../hooks/useInsuranceForm";

const InsuranceForm = () => {
  const {
    initialInsuranceValues,
    isProcessing,
    handleFormSubmit,
    handleModalClose,
  } = useInsuranceForm();

  return (
    <Formik
      enableReinitialize
      initialValues={{ ...initialInsuranceValues }}
      validationSchema={insuranceSchema}
      onSubmit={handleFormSubmit}
    >
      {({ handleSubmit, touched, errors, values, handleChange }) => (
        <>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                margin="none"
                required
                value={values.payorId}
                label="Payor ID"
                error={touched.payorId && Boolean(errors.payorId)}
                onChange={handleChange("payorId")}
                helperText={touched.payorId && errors.payorId}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                margin="none"
                required
                value={values.payorName}
                label="Insurance Name"
                error={touched.payorName && Boolean(errors.payorName)}
                onChange={handleChange("payorName")}
                helperText={touched.payorName && errors.payorName}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                margin="none"
                value={values.street}
                label="Street Address"
                error={touched.street && Boolean(errors.street)}
                onChange={handleChange("street")}
                helperText={touched.street && errors.street}
              />
            </Grid>
            <Grid item xs={12}>
              <FormControl fullWidth variant="outlined">
                <InputLabel id="demo-simple-select-label">State</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="state"
                  name="state"
                  value={values?.state}
                  onChange={handleChange("state")}
                  input={<OutlinedInput fullWidth label="State" />}
                  error={touched.state && Boolean(errors.state)}
                >
                  {states.map((state, index) => (
                    <MenuItem key={index} value={state}>
                      {state}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                margin="none"
                value={values.city}
                label="City"
                error={touched.city && Boolean(errors.city)}
                onChange={handleChange("city")}
                helperText={touched.city && errors.city}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                margin="none"
                value={values.zip}
                label="Zip"
                error={touched.zip && Boolean(errors.zip)}
                onChange={handleChange("zip")}
                helperText={touched.zip && errors.zip}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                margin="none"
                value={values.phone}
                label="Phone"
                error={touched.phone && Boolean(errors.phone)}
                onChange={handleChange("phone")}
                helperText={touched.phone && errors.phone}
              />
            </Grid>
          </Grid>

          <div
            className="d-flex flex-end"
            style={{ gap: "10px", marginTop: 15 }}
          >
            <Button
              variant="outlined"
              color="secondary"
              onClick={handleModalClose}
              disabled={isProcessing}
            >
              Cancel
            </Button>

            <SubmitButton
              variant="contained"
              color="secondary"
              handleClick={handleSubmit}
              isLoading={isProcessing}
            />
          </div>
        </>
      )}
    </Formik>
  );
};

export default InsuranceForm;
